import { chevronBackOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ModalController, NavController } from '@ionic/angular/standalone';
import { ContactUsModel } from 'src/shared/models/contact-us.model';
import { UserTowerGroupsApiService } from 'src/app/api/services';
import { AuthService } from 'src/app/core/auth/auth.service';
import { TowerGroupDto } from 'src/app/api/models';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IonButton, IonIcon, IonList, IonItem, IonLabel } from "@ionic/angular/standalone";
import { IconComponent } from "../../../../shared/components/elements/icon/icon.component";
import { NgFor, NgIf } from '@angular/common';

interface Contacts {
	facilityName: string;
	contacts: ContactUsModel[];
}

@Component({
	selector: 'vl-contact-us',
	templateUrl: './contact-us.page.html',
	styleUrls: ['./contact-us.page.scss'],
	imports: [IonLabel, IonItem, IonList, NgIf, NgFor, IonIcon, IonButton, TranslatePipe, NgSelectComponent, IconComponent]
})
export class ContactUsPage implements OnInit {
	@Input() fromModal = false;
	@Input() inputGroup: TowerGroupDto;
	contactUsModel: Array<Contacts> = [];
	groups: TowerGroupDto[];
	selectedFacilityContact: Contacts;
	loading: boolean = true;
	public isPublicView: boolean = true;

	constructor(private translate: TranslateService,
				private modalController: ModalController,
				private authService: AuthService,
				private loader: CustomSpinnerService,
				private groupsApiService: UserTowerGroupsApiService,
				private navCtrl: NavController,
	) {
    	addIcons({ chevronBackOutline });
		this.authService.$userAuth.subscribe(b => {
			this.isPublicView = !b;
		});
	}

	ngOnInit() {
		if(this.inputGroup && this.fromModal) {
			this.selectedFacilityContact = { facilityName: this.inputGroup.label, contacts: this.contactModel(this.inputGroup) };
			this.loading = false;
		}
		else {
			const groupsObs$ = this.isPublicView ? this.groupsApiService.getUserTowerGroups1(): this.groupsApiService.getUserTowerGroups();
			groupsObs$.subscribe((g) => {
				this.groups = g;
				this.fillUp(g);
			})
		}
	}

	ionViewDidEnter() {
	}

	ionViewDidLeave() {
	}

	fillUp(groups: TowerGroupDto[]) {
		for (let group of groups) {
			this.contactUsModel.push(
				{
					facilityName: group.label,
					contacts: this.contactModel(group)
				}
			);
		}
	}

	contactModel (group: TowerGroupDto) {
		let contactsList: ContactUsModel[] = [];
		for(let contact of group.organization.contacts) {
			switch (contact.type) {
				case 'EMAIL':
					contactsList.push(
						{
							icon: 'contact-us-email',
							action: `mailto:${ contact.value }?subject=${ this.translate.instant('contact-us.support-issue') }`,
							link: '',
							text: contact.value,
							type: contact.type,
							title: this.translate.instant('contact-us.email-support'),
						},
					);
					break;
				case 'PHONE':
					contactsList.push(
						{
							icon: 'contact-us-call',
							action: 'tel:' + contact.value,
							phoneString: contact.value.replace('+', ''),
							type: contact.type,
							link: '',
							text: '',
							title: this.translate.instant('contact-us.call-hotline'),
						}
					);
					break;
				case  'PHONE_FREE':
					contactsList.push(
						{
							icon: 'contact-us-call',
							action: 'tel:' + contact.value,
							phoneString: contact.value.replace('+', ''),
							link: '',
							type: contact.type,
							text: this.translate.instant('contact-us.call-hotline-text-1'),
							title: this.translate.instant('contact-us.call-hotline'),
						}
					);
					break;
				case 'CHAT_WHATSAPP':
					contactsList.push(
						{
							icon: 'contact-us-chat',
							action: `https://wa.me/${contact.value}`,
							phoneString: contact.value.replace('+', ''),
							link: contact.value,
							type: contact.type,
							text: this.translate.instant('contact-us.chat-support-text'),
							title: this.translate.instant('contact-us.chat-support'),
						},
					);
					break;
				case 'WEB':
					contactsList.push(
						{
							icon: 'web',
							action: contact.value,
							link: '',
							type: contact.type,
							text: contact.value,
							title: this.translate.instant('contact-us.website'),
						},
					);
					break;
			}
		}
		contactsList.sort((a: any, b: any) => a.type > b.type ? -1: 1);
		return contactsList;
	};

	setContacts(event: any) {
		this.loader.show();
		this.loading = true;
		setTimeout(() => {
			this.selectedFacilityContact = this.contactUsModel?.find(v => v.facilityName === event?.label);
			this.loading = false;
			this.loader.hide();
		}, 300);
	}

	back() {
		if (this.fromModal) {
			this.modalController.dismiss();
		} else {
			this.navCtrl.navigateRoot('/');
		}
	}

	onAction(type, action, event) {
		if (type === 'WEB' || type === 'CHAT_WHATSAPP') {
			this.openExternally(action, event);
		}
	}

	openExternally(action: string, event: MouseEvent) {
		// const target = cordova.platformId == 'browser' ? '_system' : '_blank';
		const target = '_blank';
		const withHttp = (url: string) => url.replace(/^(?:(.*:)?\/\/)?(.*)/i, (match, schemma, nonSchemmaUrl) => schemma ? match : `http://${nonSchemmaUrl}`);
		const link = action.includes('http') ? action: withHttp(action);
		event.preventDefault();
		window.open(link, target);
	}
}
